import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: "#212121",
            light: "#484848",
            dark: "#000000",
            contrastText: "#fff",
        },
        secondary: {
            main: "#e0e0e0", // Neutral Grey
            light: "#ffffff", // White
            dark: "#aeaeae", // Darker Grey
            contrastText: "#000", // Black text for better contrast
        },
    },
    typography: {
        fontFamily: ["Nunito Sans", "sans-serif"].join(","),
        h1: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        h2: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        h3: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        h4: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        h5: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        h6: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
        overline: { fontFamily: ["Nunito Sans", "sans-serif"].join(",") },
    },
});

export default theme;